function initArticle() {
  const articleUrl = window.location.href;
  const articleTitle = document.title;

  window.Article = {
    shareOnFacebook() {
      window.open(
        `https://www.facebook.com/sharer.php?u=${articleUrl}`,
        '',
        'height=368,width=600,left=100,top=100,menubar=0'
      );
      return false;
    },
    shareOnTwitter() {
      window.open(
        `https://twitter.com/share?url=${articleUrl}&text=${articleTitle}`,
        `${articleUrl}&text=${articleTitle}`,
        '',
        'height=260,width=500,left=100,top=100,menubar=0'
      );
      return false;
    },
    shareOnLinkedIn() {
      window.open(
        `https://www.linkedin.com/shareArticle?mini=true&url=${articleUrl}&title=${articleTitle}`,
        `${articleUrl}&title=${articleTitle}`,
        '',
        'height=260,width=500,left=100,top=100,menubar=0'
      );
      return false;
    },
  };
}

initArticle();
